import { Backdrop, CircularProgress } from '@mui/material';

export interface ILoader {
  open: boolean;
}

export const Loader: React.FC<ILoader> = props => {
  return (
    <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={props.open}>
      <CircularProgress />
    </Backdrop>
  );
};
